import { SET_APPLICATIONS, SET_COMPANY_PRODUCTS } from './actions';

const defaultState = {
	applications: [],
	// null until the probe has settled — the router must not conclude a product
	// is unreachable while the answer is still unknown.
	companyProducts: null
};

const reducer = (state = defaultState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_APPLICATIONS:
			return { ...state, applications: payload };
		case SET_COMPANY_PRODUCTS:
			return { ...state, companyProducts: payload };
		default:
			return state;
	}
};

export default reducer;
